//use strict

if (MS2JS === undefined) {
    var MS2JS = {};

    (function () {
        window['_boot'].then(() => {
            if (!globalThis.clientConfig) {
                return;
            }

            const { vnPage, vnDevice, haApp, msImages, msPreloader, msTeasers, vnUser } = globalThis.clientConfig;
            const sportsApiUrl = haApp.productApiUrls.sports;

            function toApiUrl(url) {
                try {
                    const parseUrl = new URL(url);
                    const parseApiUrl = new URL(sportsApiUrl);
                    parseUrl.hostname = parseApiUrl.hostname;
                    parseUrl.port = parseApiUrl.port;
                    url = parseUrl.href;
                } catch (e) {
                    url = sportsApiUrl + url;
                }
                return url;
            }

            MS2JS.Http = new (function () {
                return {
                    get,
                    post,
                    getMS2Api,
                };

                function getMS2Api(url, callback) {
                    const headers = {
                        'x-bwin-browser-url': globalThis.location.href,
                        'X-XSRF-TOKEN': getCookie('XSRF-TOKEN'),
                    };

                    headers['x-bwin-sports-api'] = vnPage.environment;

                    get(toApiUrl(url), callback, {
                        headers,
                    });
                }

                function get(url, callback, options) {
                    asyncRequest(url, 'GET', callback, options);
                }

                function post(url, callback, options) {
                    asyncRequest(url, 'POST', callback, options);
                }

                function asyncRequest(url, method, callback, options) {
                    options = options || {};

                    const defaultHeaders = { 'Content-Type': 'application/json;charset=UTF-8' };
                    const headers = Object.assign({}, defaultHeaders, options.headers || {});
                    const data = options.data ? JSON.stringify(options.data) : undefined;

                    return fetch(url, {
                        method,
                        cache: 'no-cache',
                        credentials: 'include',
                        headers,
                        body: data,
                    })
                        .then((res) => res.json())
                        .then((data) => callback(null, data))
                        .catch((error) => {
                            console.error(error);
                            callback(error);
                        });
                }

                function getCookie(name) {
                    const value = `; ${document.cookie}`;
                    const parts = value.split(`; ${name}=`);
                    if (parts.length === 2) return parts.pop().split(';').shift();
                }
            })();

            MS2JS.GridGroupLoader = new (function () {
                let isLoading = false;
                let groupingData = null;
                let hasError = false;
                const cdsApiHeader = 'x-bwin-cds-api';

                init();

                return {
                    loading() {
                        return isLoading;
                    },
                    error() {
                        return hasError;
                    },
                    data() {
                        return groupingData;
                    },
                    reset() {
                        isLoading = false;
                        groupingData = null;
                        hasError = false;
                    },
                };

                function init() {
                    isLoading = true;
                    MS2JS.Http.get(
                        msPreloader.groupingUrl,
                        function (error, data) {
                            hasError = !!error;
                            isLoading = false;
                            groupingData = data;
                        },
                        {
                            headers: !vnPage.isProduction
                                ? {
                                      [cdsApiHeader]: msPreloader.cdsApiUrl,
                                  }
                                : {},
                        },
                    );
                }
            })();

            MS2JS.ModularHomePageDataLoader = new (function () {
                let isLoading = false;
                let homePageData = null;
                let hasError = false;
                let requestContext = null;

                // Only one widget may own the LCP placeholder slot per page load. Each placeholder
                // position is an approximation, so rendering two of them (e.g. Teaser + Marquee)
                // makes them overlap and misalign. The owner is arbitrated by priority as each
                // candidate's payload resolves; a higher priority evicts the current placeholder.
                // The evicted placeholder's MutationObserver and timeout are torn down at eviction
                // time so nothing keeps observing a removed node.
                const LCP_PLACEHOLDER_PRIORITY = { showcase: 3, teaser: 2, marquee: 1 };
                let lcpPlaceholderOwner = null;
                let lcpPlaceholderOwnerPriority = 0;
                let lcpPlaceholderCleanup = null;

                init();

                return {
                    loading() {
                        return isLoading;
                    },
                    error() {
                        return hasError;
                    },
                    data() {
                        return homePageData;
                    },
                    requestContext() {
                        return requestContext;
                    },
                    reset() {
                        isLoading = false;
                        requestContext = null;
                        homePageData = null;
                        hasError = false;
                        lcpPlaceholderOwner = null;
                        lcpPlaceholderOwnerPriority = 0;
                        lcpPlaceholderCleanup = null;
                    },
                };

                function init() {
                    const isSportsLobby = isOnSportsLobby();
                    if (!isOnHomepage() && !isSportsLobby) {
                        return;
                    }

                    const context = prepareContext(isSportsLobby, getScreenSize());
                    const url = constructUrl(context);

                    isLoading = true;
                    const screenSize = getScreenSize();

                    if (!isOnHomepage() && !isSportsLobby) {
                        return;
                    }

                    isLoading = true;

                    fetchData(url, (error, data) => {
                        hasError = !!error;
                        isLoading = false;
                        homePageData = data;
                        requestContext = context;

                        if (data?.widgets) {
                            preloadLcpImages(data.widgets);
                            preloadWidgetData(data.widgets, screenSize, isSportsLobby, requestContext.sportId);
                        }
                    });
                }

                function prepareContext(isSportsLobby, screenSize, widgetId) {
                    if (isSportsLobby) {
                        const sportsIdStr = globalThis.location.pathname.split('-').at(-1);

                        return {
                            page: 'SportLobby',
                            layoutSize: screenSize,
                            sportId: Number.parseInt(sportsIdStr),
                        };
                    }

                    return {
                        page: 'HomeLobby',
                        layoutSize: screenSize,
                        widgetId,
                        promoBannerPreview: globalThis.location.search.includes('offerId') && globalThis.location.search.includes('sitecoreId'),
                    };
                }

                function constructUrl(context) {
                    const url = new URL(`${msPreloader.pagePrefix}/api/widget`, `${globalThis.location.protocol}//${globalThis.location.host}`);
                    url.searchParams.set('layoutSize', context.layoutSize);
                    url.searchParams.set('page', context.page);
                    if (context.page === 'SportLobby') {
                        url.searchParams.set('sportId', context.sportId);
                    }

                    if (context.widgetId) {
                        url.pathname += '/widgetdata';
                        url.searchParams.set('widgetId', context.widgetId);
                        url.searchParams.set('shouldIncludePayload', 'true');
                    }

                    if (vnUser.isAuthenticated) {
                        url.searchParams.set('isAuth', '1');
                    }

                    if (context.promoBannerPreview) {
                        url.searchParams.set('promoBannerPreview', 'true');
                    }

                    return decodeURIComponent(url.pathname + url.search);
                }

                async function preloadWidgetData(widgets, screenSize, isSportLobby, sportId) {
                    const deviceType = !vnDevice.isMobile ? 'desktop' : vnDevice.isTablet ? 'tablet' : 'phone';
                    const requestInit = {
                        headers: {
                            'accept': 'application/json, text/plain, */*',
                            'X-From-Product': vnPage.product,
                            'x-bwin-browser-url': globalThis.location.href,
                            'x-app-context': 'default',
                            'x-device-type': `${deviceType}_${vnDevice.osName}`,
                            'sports-api-version': 'SportsAPIv2',
                        },
                    };

                    requestInit.headers['x-bwin-sports-api'] = vnPage.environment;

                    await Promise.all(
                        widgets
                            .filter((widget) => !widget.shouldIncludePayload && ['Center', 'Top'].includes(widget.location))
                            .sort((a, b) => a.order - b.order)
                            .slice(0, 6)
                            .map((widget) => {
                                const baseUrl = sportsApiUrl || `${globalThis.location.protocol}//${globalThis.location.host}`;
                                const url = new URL(`${msPreloader.pagePrefix}/api/widget/widgetdata`, baseUrl);
                                // ?layoutSize=${screenSize}&page=HomeLobby&widgetId=${widget.id}&shouldIncludePayload=true
                                url.searchParams.set('layoutSize', screenSize);
                                url.searchParams.set('page', isSportLobby ? 'SportLobby' : 'HomeLobby');
                                if (sportId) {
                                    url.searchParams.set('sportId', sportId);
                                }
                                url.searchParams.set('widgetId', widget.id);
                                if (widget.type == 'TopEvents') {
                                    url.searchParams.set('useAggregateMatchList', globalThis.clientConfig.msTopEvents.useAggregateMatchList);
                                }
                                url.searchParams.set('shouldIncludePayload', true);
                                if (widget.type === 'ShowCase') {
                                    return fetch(decodeURIComponent(url.href), requestInit)
                                        .then((response) => (response.ok ? response.json() : null))
                                        .then((data) => {
                                            if (data?.widgets?.length) {
                                                const showcaseWidget = data.widgets.find((w) => w.visible && w.type === 'ShowCase');
                                                if (
                                                    showcaseWidget &&
                                                    globalThis.clientConfig.msPreloader?.showcaseLcpPlaceholderWaitForSelector &&
                                                    screenSize === 'Small'
                                                ) {
                                                    createShowcasePlaceholder(showcaseWidget);
                                                }
                                            }
                                        });
                                }
                                if (widget.type === 'RotatingTeaser') {
                                    return fetch(decodeURIComponent(url.href), requestInit)
                                        .then((response) => (response.ok ? response.json() : null))
                                        .then((data) => {
                                            if (data?.widgets?.length) {
                                                const teaserWidget = data.widgets.find((w) => w.visible && w.type === 'RotatingTeaser');
                                                if (
                                                    teaserWidget &&
                                                    globalThis.clientConfig.msPreloader?.teaserLcpPlaceholderWaitForSelector &&
                                                    screenSize === 'Small'
                                                ) {
                                                    createTeaserPlaceholder(teaserWidget);
                                                }
                                            }
                                        });
                                }
                                if (widget.type === 'Marquee') {
                                    url.searchParams.set('marqueesOnly', true);
                                    url.searchParams.set('shouldIncludePersonalizedData', false);
                                    const personalizedUrl = new URL(url.href.replace('widgetdata', 'personalizedWidgetData'));
                                    personalizedUrl.searchParams.set('shouldIncludePersonalizedData', true);
                                    return Promise.all([
                                        fetch(decodeURIComponent(url.href), requestInit).then((response) => (response.ok ? response.json() : [])),
                                        fetch(decodeURIComponent(personalizedUrl.href), requestInit).then((response) =>
                                            response.ok ? response.json() : [],
                                        ),
                                    ]).then(([marqueeData, personalizedData]) => {
                                        const regularWidget = marqueeData.widgets
                                            ?.filter((w) => w.visible && w.type === 'Marquee')
                                            .sort((a, b) => a.order - b.order)?.[0];
                                        const personalizedWidget = personalizedData.widgets
                                            ?.filter((w) => w.visible && w.type === 'Marquee')
                                            .sort((a, b) => a.order - b.order)?.[0];
                                        const widget = regularWidget || personalizedWidget;
                                        var firstTile = getFirstMarqueeTile(regularWidget?.payload, personalizedWidget?.payload);
                                        preloadMarqueeLcp(widget, regularWidget?.payload, personalizedWidget?.payload);
                                        if (globalThis.clientConfig.msMarquee?.lcpPlaceholderWaitForSelector && screenSize === 'Small') {
                                            createMarqueePlaceholder(widget, firstTile);
                                        }
                                    });
                                }
                                return fetch(decodeURIComponent(url.href), requestInit);
                            }),
                    );
                }

                function getScreenSize() {
                    if (globalThis.matchMedia('(min-width:601px) and (max-width: 1279px)').matches) {
                        return 'Medium';
                    } else if (globalThis.matchMedia('(min-width: 1280px)').matches) {
                        return 'Large';
                    }

                    return 'Small';
                }

                function preloadLcpImages(widgets) {
                    const screenSize = getScreenSize();
                    const staticTeaser = widgets.find((widget) => widget.type === 'StaticTeaser');
                    preloadStaticTeaserLcp(staticTeaser);
                    const storyContent = widgets.find((widget) => widget.type === 'StoryContent');
                    preloadStoryContentLcp(storyContent);
                    const teaser = widgets.find((widget) => widget.type === 'RotatingTeaser');
                    preloadTeaserLcp(teaser);
                    const marquee = widgets.find((widget) => widget.type === 'Marquee');
                    preloadMarqueeLcp(marquee, marquee?.payload, null);
                    const casinoBanner = widgets.find((widget) => widget.type === 'Banner' && !!widget.payload?.imageUrl);
                    preloadCasinoBannerLcp(casinoBanner);
                    const popularBets = widgets.filter((widget) => widget.type === 'PopularMultiBets' && widget.visible);
                    preloadPopularBetsLcp(popularBets);
                    createUpfrontLcpPlaceholders(widgets, screenSize);
                }

                function createUpfrontLcpPlaceholders(widgets, screenSize) {
                    if (screenSize !== 'Small') {
                        return;
                    }

                    const config = globalThis.clientConfig;

                    const showcase = widgets.find((widget) => widget.type === 'ShowCase' && widget.visible !== false);
                    if (config.msPreloader?.showcaseLcpPlaceholderWaitForSelector) {
                        createShowcasePlaceholder(showcase);
                    }

                    const teaser = widgets.find((widget) => widget.type === 'RotatingTeaser' && widget.visible !== false);
                    if (config.msPreloader?.teaserLcpPlaceholderWaitForSelector) {
                        createTeaserPlaceholder(teaser);
                    }
                }

                /**
                 * Removes the placeholder element that currently owns the LCP slot so a higher-priority
                 * candidate can take its place without the two overlapping.
                 */
                function removeLcpPlaceholder() {
                    if (!lcpPlaceholderOwner) {
                        return;
                    }

                    if (lcpPlaceholderCleanup) {
                        lcpPlaceholderCleanup();
                        lcpPlaceholderCleanup = null;
                    }

                    const existing = document.getElementById(lcpPlaceholderOwner);
                    if (existing) {
                        existing.dataset.dismissed = 'true';
                        existing.remove();
                    }

                    lcpPlaceholderOwner = null;
                    lcpPlaceholderOwnerPriority = 0;
                }

                /**
                 * Priority gate shared by all three candidates. Returns true when `priority` may claim
                 * the LCP slot - i.e. nothing owns it yet, or the incoming candidate outranks the
                 * current owner, in which case the current placeholder is evicted first. A lower or
                 * equal priority (including a re-entrant call from the same owner) returns false.
                 */
                function claimLcpPlaceholder(priority) {
                    if (priority <= lcpPlaceholderOwnerPriority) {
                        return false;
                    }

                    removeLcpPlaceholder();

                    return true;
                }

                function preloadPopularBetsLcp(widgets) {
                    const isSportsLobby = isOnSportsLobby();
                    const screenSize = getScreenSize();
                    const preloadImages = new Set();
                    for (const widget of widgets) {
                        if (!widget.id) continue;

                        const context = prepareContext(isSportsLobby, screenSize, widget.id);
                        const url = constructUrl(context);

                        fetchData(url, (error, data) => {
                            if (error || !data?.widgets?.length) return;

                            const widget = data.widgets[0];
                            if (!widget.visible || !widget.payload?.pods?.length) return;

                            for (const pod of widget.payload.pods) {
                                const { backgroundImage } = pod;
                                if (backgroundImage && !preloadImages.has(backgroundImage.src)) {
                                    preloadImages.add(backgroundImage.src);
                                    createImagePreloadLink(backgroundImage.src);
                                }
                            }
                        });
                    }
                }

                function fetchData(url, callback) {
                    MS2JS.Http.getMS2Api(url, function (error, data) {
                        callback(error, data);
                    });
                }

                function preloadStoryContentLcp(widget) {
                    if (widget) {
                        const stories = widget.payload.stories;
                        const story = stories?.length > 0 ? stories[0] : null;
                        if (story?.tileImage) {
                            const stretch = stories.length > 1;
                            const imageUrl = new URL(story?.tileImage);
                            const backgroundWidth = stretch ? '540' : '160';
                            const qualityParam = `width${backgroundWidth}`;

                            imageUrl.searchParams.set('p', qualityParam);
                            createImagePreloadLink(imageUrl.toString());
                        }
                    }
                }

                function getFirstMarqueeTile(regularPayload, personalizedPayload) {
                    var regularTiles = regularPayload?.tiles || [];
                    var personalizedTiles = personalizedPayload?.tiles || [];
                    var combinedTiles = regularTiles.concat(personalizedTiles);

                    if (!combinedTiles.length) {
                        return null;
                    }

                    // Replicate mergeMarqueePayload sorting: sort by sitecoreIds order
                    if (personalizedPayload && !personalizedPayload.isPersonalizedMarquee && personalizedTiles.length) {
                        var sitecoreIds = personalizedPayload.sitecoreIds || [];
                        if (sitecoreIds.length) {
                            combinedTiles.sort(function (a, b) {
                                var aId = a.trackingDetail?.sitecoreTemplateId || '';
                                var bId = b.trackingDetail?.sitecoreTemplateId || '';
                                aId = aId.slice(Math.max(0, aId.lastIndexOf('/') + 1));
                                bId = bId.slice(Math.max(0, bId.lastIndexOf('/') + 1));
                                return sitecoreIds.indexOf(aId) - sitecoreIds.indexOf(bId);
                            });
                        }
                    }

                    return combinedTiles[0];
                }

                function preloadMarqueeLcp(widget, regularPayload, personalizedPayload) {
                    var tile = getFirstMarqueeTile(regularPayload, personalizedPayload);
                    if (!tile && widget?.payload?.tiles?.length > 0) {
                        tile = widget.payload.tiles[0];
                    }
                    if (tile?.imageUrl) {
                        var srcSet = ['280', '560'].map(function (size, i) {
                            return appendWidthParam(tile.imageUrl, size) + ' ' + (i + 1) + 'x';
                        });
                        createImagePreloadLink(tile.imageUrl, null, srcSet);
                    }
                }

                function preloadTeaserLcp(widget) {
                    if (widget) {
                        const teasers = widget.payload.teasers;
                        if (teasers?.length > 0 && teasers[0].imageUrl) {
                            const imageUrl = teasers[0].imageUrl;
                            const srcSet = ['480', '640', '768'].map((size) => `${appendWidthParam(imageUrl, size)} ${size}w`).join(', ');
                            const sizes = '(min-width: 960px) 768px, 100vw';
                            createImagePreloadLink(imageUrl, sizes, srcSet);
                        }
                    }
                }

                function getContentTopOffset() {
                    // Taken from row labels - similar across labels
                    return 128;
                }

                function getShowCaseContentTopOffset() {
                    // Taken from de labels - navigation with header
                    return 168;
                }

                /**
                 * Generic LCP placeholder creator.
                 * @param {Object} config - Placeholder configuration
                 * @param {string} config.id - Placeholder element ID (e.g., 'preloader-marquee-lcp')
                 * @param {string} config.containerStyle - CSS style string for the container
                 * @param {string} [config.imageUrl] - Image URL (for img-based placeholders)
                 * @param {string} [config.srcSet] - Image srcset attribute
                 * @param {string} [config.sizes] - Image sizes attribute
                 * @param {string} [config.backgroundImage] - CSS background-image value (for background-based placeholders)
                 * @param {boolean} [config.preloadImage] - Whether to create a preload link for the image
                 * @param {string} [config.waitForSelector] - CSS selector to wait for before showing placeholder
                 * @param {number} config.priority - LCP-slot priority; the created placeholder becomes the owner at this rank
                 * @param {string} config.errorContext - Context string for error logging
                 * @returns {boolean} true when this call claimed the LCP placeholder slot
                 */
                function createLcpPlaceholder(config) {
                    try {
                        if (document.getElementById(config.id)) {
                            return false;
                        }

                        const container = document.createElement('div');
                        container.id = config.id;
                        container.style = config.containerStyle;

                        if (config.backgroundImage) {
                            // Background-image based placeholder (e.g., showcase)
                            container.style.backgroundImage = config.backgroundImage;
                            if (config.preloadImage && config.imageUrl) {
                                createImagePreloadLink(config.imageUrl);
                            }
                        } else if (config.imageUrl) {
                            // Img element based placeholder (e.g., marquee, teaser)
                            const img = document.createElement('img');
                            img.src = config.imageUrl;
                            if (config.srcSet) {
                                img.srcset = config.srcSet;
                            }
                            if (config.sizes) {
                                img.sizes = config.sizes;
                            }
                            img.fetchPriority = 'high';
                            img.style = 'width: 100%; height: 100%; object-fit: cover;';
                            container.append(img);
                        } else {
                            return false; // No image data, skip placeholder
                        }

                        container.style.display = 'none';
                        document.body.insertBefore(container, document.body.firstChild);

                        const waitSelector = config.waitForSelector;
                        if (!waitSelector) {
                            container.remove();
                            return false;
                        }

                        lcpPlaceholderOwner = config.id;
                        lcpPlaceholderOwnerPriority = config.priority;

                        // Real element already present - show immediately, no observer needed.
                        if (document.querySelector(waitSelector)) {
                            container.style.display = '';
                            lcpPlaceholderCleanup = null;
                            return true;
                        }

                        const observer = new MutationObserver((mutations, obs) => {
                            if (container.dataset.dismissed) {
                                obs.disconnect();
                                return;
                            }
                            if (document.querySelector(waitSelector)) {
                                container.style.display = '';
                                obs.disconnect();
                            }
                        });

                        observer.observe(document.body, { childList: true, subtree: true });

                        const timeoutId = setTimeout(() => {
                            observer.disconnect();
                            container.style.display = 'none';
                        }, 10000);

                        lcpPlaceholderCleanup = () => {
                            observer.disconnect();
                            clearTimeout(timeoutId);
                        };

                        return true;
                    } catch (error) {
                        console.error('LCP ' + config.errorContext + ' placeholder error:', error);

                        return false;
                    }
                }

                function createMarqueePlaceholder(widget, mergedFirstTile) {
                    const tile = mergedFirstTile || widget?.payload?.tiles?.[0];
                    if (!tile?.imageUrl) {
                        return false;
                    }

                    if (!claimLcpPlaceholder(LCP_PLACEHOLDER_PRIORITY.marquee)) {
                        return false;
                    }

                    const imageUrl = tile.imageUrl;
                    const srcSet = ['280', '560'].map((size, i) => `${appendWidthParam(imageUrl, size)} ${i + 1}x`).join(', ');
                    const top = getContentTopOffset();

                    return createLcpPlaceholder({
                        id: 'preloader-marquee-lcp',
                        priority: LCP_PLACEHOLDER_PRIORITY.marquee,
                        containerStyle:
                            'position: absolute; top: ' +
                            top +
                            'px; left: 8px; width: 280px; height: 140px; overflow: hidden; z-index: 2; border-radius: 8px;',
                        imageUrl: imageUrl,
                        srcSet: srcSet,
                        waitForSelector: globalThis.clientConfig.msMarquee?.lcpPlaceholderWaitForSelector,
                        errorContext: 'marquee',
                    });
                }

                function createTeaserPlaceholder(widget) {
                    const teasers = widget?.payload?.teasers;
                    if (!teasers?.length || !teasers[0].imageUrl) {
                        return false;
                    }

                    // Teaser outranks the marquee but yields to the showcase.
                    if (!claimLcpPlaceholder(LCP_PLACEHOLDER_PRIORITY.teaser)) {
                        return false;
                    }

                    const imageUrl = teasers[0].imageUrl;
                    const srcSet = ['480', '640', '768'].map((size) => `${appendWidthParam(imageUrl, size)} ${size}w`).join(', ');
                    const sizes = '(min-width: 960px) 768px, 100vw';
                    const top = getContentTopOffset();
                    const aspectRatio = msTeasers?.teaserAspectRatio ?? 3.2;

                    return createLcpPlaceholder({
                        id: 'preloader-teaser-lcp',
                        priority: LCP_PLACEHOLDER_PRIORITY.teaser,
                        containerStyle:
                            'position: absolute; top: ' +
                            top +
                            'px; left: 0; width: 100%; aspect-ratio: ' +
                            aspectRatio +
                            '; max-height: 240px; overflow: hidden; z-index: 2;',
                        imageUrl: imageUrl,
                        srcSet: srcSet,
                        sizes: sizes,
                        waitForSelector: globalThis.clientConfig.msPreloader?.teaserLcpPlaceholderWaitForSelector,
                        errorContext: 'teaser',
                    });
                }

                function createShowcasePlaceholder(widget) {
                    const fixtures = widget?.payload?.fixtures;
                    if (!fixtures?.length) {
                        return false;
                    }

                    // Get sport ID from first fixture
                    const sportId = fixtures[0]?.fixture?.sport?.id;
                    if (!sportId) {
                        return false;
                    }

                    // Look up background image from config
                    const backgrounds = globalThis.clientConfig.msShowcase?.backgrounds || [];
                    const background = backgrounds.find((bg) => bg.id === sportId || bg.id === String(sportId));
                    if (!background?.imageSrc) {
                        return false;
                    }

                    let imageUrl = background.imageSrc;
                    // Apply image quality params if configured
                    if (msImages?.imageQualityParams?.homePage?.showCase) {
                        imageUrl = setImageQuality(
                            imageUrl,
                            msImages.imageQualityParams.allowedImageTypes,
                            msImages.imageQualityParams.homePage.showCase,
                        );
                    }
                    const appendValue = imageUrl.includes('?') ? '&p=width540' : '?p=width540';
                    imageUrl = imageUrl + appendValue;

                    // Showcase is the highest-priority (largest) candidate.
                    if (!claimLcpPlaceholder(LCP_PLACEHOLDER_PRIORITY.showcase)) {
                        return false;
                    }

                    const top = getShowCaseContentTopOffset();

                    return createLcpPlaceholder({
                        id: 'preloader-showcase-lcp',
                        priority: LCP_PLACEHOLDER_PRIORITY.showcase,
                        containerStyle:
                            'position: absolute; top: ' +
                            top +
                            'px; left: 0; width: 100%; height: 340px; overflow: hidden; z-index: 2; background-size: cover; background-position: center;',
                        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(' + imageUrl + ')',
                        imageUrl: imageUrl,
                        preloadImage: true,
                        waitForSelector: globalThis.clientConfig.msPreloader?.showcaseLcpPlaceholderWaitForSelector,
                        errorContext: 'showcase',
                    });
                }

                function preloadStaticTeaserLcp(widget) {
                    if (widget) {
                        const teaser = widget.payload;
                        if (teaser?.imageUrl) {
                            const imageUrl = `${teaser.imageUrl}?p=width540`;
                            createImagePreloadLink(imageUrl);
                        }
                    }
                }

                function preloadCasinoBannerLcp(widget) {
                    if (widget) {
                        let imageUrl = widget.payload.imageUrl;
                        if (msImages?.imageQualityParams?.homePage?.casinoBanner) {
                            imageUrl = setImageQuality(
                                imageUrl,
                                msImages.imageQualityParams.allowedImageTypes,
                                msImages.imageQualityParams.homePage.casinoBanner,
                            );
                        }
                        createImagePreloadLink(imageUrl);
                    }
                }

                function setImageQuality(imageSource, allowedImageTypes, qualityValue) {
                    const allowedExtensions = new RegExp(allowedImageTypes, 'i');

                    if (imageSource && imageSource.match(allowedExtensions) && !imageSource.includes('q='))
                        return (imageSource += imageSource.includes('?') ? `&${qualityValue}` : `?${qualityValue}`);

                    return imageSource;
                }

                // Sitecore media urls may already carry a query string (e.g. `?qd=70`), so the
                // width param needs the right separator — `?w=` twice yields a malformed url.
                function appendWidthParam(imageUrl, width) {
                    return `${imageUrl}${imageUrl.includes('?') ? '&' : '?'}w=${width}`;
                }

                function createImagePreloadLink(src, sizes, srcSet) {
                    const preloadLink = document.createElement('link');
                    preloadLink.rel = 'preload';
                    preloadLink.href = src;
                    if (sizes) {
                        preloadLink.imageSizes = sizes;
                    }
                    if (srcSet) {
                        preloadLink.imageSrcset = srcSet;
                    }
                    preloadLink.as = 'image';
                    preloadLink.setAttribute('fetchpriority', 'high');
                    document.head.append(preloadLink);
                }
            })();

            MS2JS.SiteMapLoader = new (function () {
                let isLoading = false;
                let siteMapData = null;
                let hasError = false;

                init();

                return {
                    loading() {
                        return isLoading;
                    },
                    error() {
                        return hasError;
                    },
                    data() {
                        return siteMapData;
                    },
                    reset() {
                        isLoading = false;
                        siteMapData = null;
                        hasError = false;
                    },
                };

                function init() {
                    if (!msPreloader.loadSitemap) {
                        return;
                    }

                    isLoading = true;

                    const useFlexibleSitemap = globalThis.clientConfig.msLayoutNavigation?.isFlexibleTopNavV3Enabled;
                    const query = useFlexibleSitemap ? '?flexible=true' : '';

                    MS2JS.Http.getMS2Api(`${msPreloader.pagePrefix}/api/sitemap${query}`, function (error, data) {
                        hasError = !!error;
                        isLoading = false;
                        siteMapData = data;
                    });
                }
            })();

            MS2JS.TeaserPricesTableLoader = new (function () {
                let isLoading = false;
                let teaserPrices = null;
                let hasError = false;

                init();

                return {
                    loading() {
                        return isLoading;
                    },
                    error() {
                        return hasError;
                    },
                    data() {
                        return teaserPrices;
                    },
                    reset() {
                        isLoading = false;
                        teaserPrices = null;
                        hasError = false;
                    },
                };

                function init() {
                    isLoading = true;
                    MS2JS.Http.getMS2Api(`${msPreloader.pagePrefix}/api/teaserbet/getLatestTeaserPrices`, function (error, data) {
                        hasError = !!error;
                        isLoading = false;
                        teaserPrices = data;
                    });
                }
            })();

            function isOnSportsLobby() {
                const sportsRegex = /sports\/[^/]+-\d{1,3}\/?$/gm;
                return sportsRegex.test(decodeURI(globalThis.location.pathname));
            }

            function isOnHomepage() {
                const homepageUrlRegex = new RegExp(`${msPreloader.pagePrefix}$`, 'i');
                return homepageUrlRegex.test(globalThis.location.pathname);
            }
        });
    })();
}
